var map = {
	"./donuts-taste-great.md": 845,
	"./every-conference-call-ever.md": 846,
	"./give-yourself-a-break.md": 847,
	"./manifesto.md": 848,
	"./meeting-arcade.md": 849,
	"./meeting-with-purpose.md": 850,
	"./meetings-didnt-become-emails.md": 851,
	"./nice-try-meetings.md": 852,
	"./no-lunch-for-you.md": 853,
	"./sick-days.md": 854,
	"./soul-crushing-meeting.md": 855,
	"./struggle-is-real.md": 856,
	"./time-to-relax.md": 857,
	"./working-from-home.md": 858,
	"./your-employees-will-quit.md": 859,
	"./your-job-keeps-you-from-getting-work-done.md": 860,
	"./zoom-contributions.md": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;